/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { styled, css, useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery, Box } from '@mui/material';
import sanitize from 'sanitize-html';

const CARDS_CONTENT = [
  `Prenez RDV en ligne pour un motif de consultation vidéo avec un médecin ou trouvez en un disponible en téléconsultation sans RDV.`,
  `Munissez vous de votre smartphone ou bien de votre ordinateur (<a href="/teleconsultation/article/comment-faire-une-teleconsultation/materiel-teleconsultation" target='_blank' rel='noopener'>muni d’une webcam et d’un micro</a>) et isolez vous dans un endroit calme.`,
  `Appelez votre professionnel de santé en visio et expliquez lui vos symptômes.`,
  `Obtenez votre <a href="/teleconsultation/article/ordonnance-en-ligne" target='_blank' rel='noopener'>ordonnance</a> ou un <a href="/teleconsultation/article/comment-faire-une-teleconsultation/teleconsultation-recevoir-un-arret-de-travail-en-ligne" target='_blank' rel='noopener'>arrêt de travail</a> directement sur votre smartphone.`,
];

const CardsWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${theme.spacing(6)} auto 0;
    max-width: 1000px;

    ${theme.breakpoints.up('md')} {
      flex-direction: row;
      align-items: stretch;
    }
  `,
);

const Card = styled(Box)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.palette.background.primary};
    padding: ${theme.spacing(2)};
    border-radius: ${theme.spacing(1)};
    box-shadow: ${theme.shadows[3]};
    flex: 1 0 100%;
    max-width: 480px;
    margin-bottom: ${theme.spacing(3)};

    ${theme.breakpoints.up('md')} {
      flex-basis: 216px;
      &:not(:last-child) {
        margin-right: ${theme.spacing(3)};
      }
    }
  `,
);

const CardNumber = styled(Typography)(
  ({ theme }) => css`
    height: ${theme.spacing(5)};
    width: ${theme.spacing(5)};
    line-height: ${theme.spacing(5)};
    border-radius: 50%;
    background-color: ${theme.palette.primary.main};
    text-align: center;
    color: ${theme.palette.primary.contrastText};
    margin-bottom: ${theme.spacing(2)};
  `,
);

const TlcHowItWorkSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      <Typography
        variant={isMobile ? 'h3' : 'h2'}
        color="primary.contrastText"
        component="h2"
        textAlign={{ sm: 'center' }}
        mt={4}
        mb={1}
      >
        Téléconsultation en ligne : comment ça marche ?
      </Typography>
      <Typography color="primary.contrastText" textAlign={{ sm: 'center' }}>
        Rien de bien compliqué ! Vous pouvez faire votre téléconsultation en
        quelques étapes :
      </Typography>

      <CardsWrapper className="blue-links">
        {CARDS_CONTENT.map((card, index) => (
          <Card key={card.substring(0, 10)}>
            <CardNumber variant="h3">{index + 1}</CardNumber>
            <Typography
              // "dangerouslySetInnerHTML" because cards contain links
              dangerouslySetInnerHTML={{
                __html: sanitize(card, { allowedTags: ['a'] }),
              }}
            />
          </Card>
        ))}
      </CardsWrapper>

      <Typography
        sx={{
          textAlign: { sm: 'center' },
          color: 'primary.contrastText',
          marginTop: 3,
          marginBottom: 4,
          a: { textDecoration: 'underline' },
        }}
      >
        Pour en savoir plus, n’hésitez pas à lire notre article dédié à ce sujet
        :{' '}
        <a
          href="/teleconsultation/article/comment-faire-une-teleconsultation"
          target="_blank"
          rel="noopener"
        >
          Comment faire une téléconsultation
        </a>
      </Typography>
    </Box>
  );
};

export default TlcHowItWorkSection;
